<template>
    <div class="cell">
        <product-filter-group
            v-if="type !== 'rf-power'"

            :model-count="count.model"
            :series-count="count.series"
            :filter-config="filterConfig"
            :active-filters="active_filters"
            :filters-query-string="active_filters_query_string"
            :valid-filters-endpoint="validFiltersEndpoint"
            :units="filterUnits"

            @filter-reset="filterReset"
            @toggle-filter="toggleFilter"
            @change-range="applyRange"
        />
        <product-list-toggle
            v-if="type !== 'rf-power'"

            :limit="limit"
            :show-series="show_series"

            @change-limit="applyLimit"
            @toggle-show-series="toggleShowSeries"
        />
        <product-list
            :type="type"
            :show-series="show_series"
            :limit="limit"
            :model-endpoint="modelEndpoint"
            :series-endpoint="seriesEndpoint"
            :stock-check-endpoint="stockCheckEndpoint"
            :filters-query-string="active_filters_query_string"
            :show-banner="configurableSelected"
            @product-list-updated="setProductCounts"
        />
    </div>
</template>

<script>
//components
import ProductListToggle from './ProductListToggle'
import ProductList from './lists/ProductList'
import ProductFilterGroup from './filters/ProductFilterGroup'
//mixins
import ObjectToLaravelGetParams from '../../../mixins/ultility/ObjectToLaravelGetParams'
// Node Modules
import debounce from 'lodash.debounce'
import isEqual from 'lodash.isequal'

export default {
    name: 'ProductCategoryPage',
    components: {ProductFilterGroup, ProductList, ProductListToggle},
    mixins: [ObjectToLaravelGetParams],
    props: {
        type: {
            type: String,
            required: true,
        },
        filterConfig: {
            type: Object,
            required: true,
        },
        modelEndpoint: {
            type: String,
            required: true,
        },
        seriesEndpoint: {
            type: String,
            required: true,
        },
        validFiltersEndpoint: {
            type: String,
            required: true,
        },
        filterUnits: {
            type: Object,
            required: true,
        },
        activeFilters: {
            type: Object,
            required: false,
            default: () => ({}),
        },
        stockCheckEndpoint: {
            type: String,
            required: true
        },
        searchCreateEndpoint: {
            type: String,
            required: true,
        },
        searchGetEndpoint: {
            type: String,
            required: true,
        },
        searchUuid: {
            type: String,
            required: false,
            default: '',
        }
    },
    data: (vm) => {
        const initial_filters = vm.parseInitialFilters();

        // Retrieve the stored toggle state or use default value based on `type`
        const toggleState = JSON.parse(sessionStorage.getItem('product-toggle')) || {};
        const show_series = toggleState[vm.type] ?? (vm.type === 'high-voltage-power-solutions');

        vm.getSearch();

        return {
            active_filters: initial_filters,
            active_filters_query_string: vm.serialiseObjectToLaravelSyntax(initial_filters),
            show_series,
            limit: 20,
            count: {
                model: {
                    count: 0,
                    loading: true
                },
                series: {
                    count: 0,
                    loading: true
                },
            },
            debounce_threshold_milliseconds: 1250
        }
    },
    methods: {
        toggleShowSeries() {
            // Invert the `show_series` value
            this.show_series = !this.show_series;

            // Save the updated state in session storage
            const toggleState = JSON.parse(sessionStorage.getItem('product-toggle')) || {};
            toggleState[this.type] = this.show_series;
            sessionStorage.setItem('product-toggle', JSON.stringify(toggleState));
        },
        filterReset(name) {
            //if no filter index is passed through, reset all filters
            name
                ? this.$delete(this.active_filters, name)
                : this.$set(this, 'active_filters', {is_initial: false})
        },
        toggleFilter(name, option) {
            //create the master filter object if not set
            !this.active_filters[name] && (this.$set(this.active_filters, name, {}))

            //create the filter values array if not set
            !this.active_filters[name]?.vals && (this.$set(this.active_filters[name], 'vals', []))

            //add value if it doesn't exist, remove it if it does
            const exists = this.active_filters[name]
                .vals
                .find(val => isEqual(val,option))

            //if the filter option already exists return all filter options bar the one selected
            //else push the new val in and return the new object
            const set_val = exists
                ? this.active_filters[name]
                    .vals
                    .filter(val => !isEqual(val,option))
                : this.active_filters[name]
                    .vals
                    .push(option)
                && this.active_filters[name].vals

            //set the new values (done this way so vue is aware of the object change)
            this.$set(
                this.active_filters[name],
                'vals',
                set_val
            )
        },
        applyRange(name, property, value) {
            //create the master filter object if not set
            !this.active_filters[name] && (this.$set(this.active_filters, name, {}))

            //create the range object if not set
            !this.active_filters[name]?.range && (this.$set(this.active_filters[name], 'range', {}))

            //set the new range (done this way so vue is aware of the object change)
            this.$set(
                this.active_filters[name].range,
                property,
                value
            )
        },
        applyLimit(limit) {
            this.limit = limit;
        },
        setProductCounts(series, count) {
            //update the relevant result count, based on which list is emitting the value
            series
                ? this.count.series = {
                    count: count,
                    loading: false,
                }
                : this.count.model = {
                    count: count,
                    loading: false,
                }
        },
        setQueryFilterString: debounce(
            function () {
                //convert the active filters object into a laravel request string so that laravel can read it as an indexed/multidimensional array
                this.active_filters_query_string = this.serialiseObjectToLaravelSyntax(this.active_filters)
            },
            500
        ),
        parseInitialFilters() {
            return this.activeFilters
        },
        getSearch() {
            this.searchUuid
            && axios.get(this.searchGetEndpoint.replace('#', this.searchUuid))
                .then(response => {
                    this.$set(this, 'active_filters', response.data)
                })
        },
        saveSearch() {
            axios.post(this.searchCreateEndpoint, {
                filters: this.active_filters,
                uuid: new URLSearchParams(window.location.search).get('q'),
            })
                .then(response => {
                    const url = new URL(window.location)

                    url.search = `?q=${response.data}`

                    window.history.pushState({}, '', url)
                })
        }
    },
    computed: {
        configurableSelected() {
            return !!this.active_filters?.format?.vals?.find(format => format.val === 'Configurable')
        }
    },
    watch: {
        active_filters: {
            handler() {
                //when the active filters change fire a debounced method
                this.setQueryFilterString()
                this.saveSearch()

                this.count.series.loading = true
                this.count.model.loading = true
            },
            deep: true,
        }
    }
}
</script>
